export default class BaseError extends Error {

}